import React from 'react';
import ProductModal from '../../components/Modal/ProductModal';
import HeaderSeven from '../../components/Header/HeaderSeven';
import ShopDetailsMain from './ShopDetailsMain';
import Footer from '../../components/Footer';

const ShopDetails = () => {
  return (
    <>
      <ProductModal />

      <HeaderSeven />

      <ShopDetailsMain />

      <Footer />
    </>
  );
};

export default ShopDetails;
